import { suggestionsFailure, suggestionsRequest, suggestionsSuccess } from './actions';
import { fetchSuggestions } from '../../services/fetchSuggestions';
import { TThunkAction } from '../../types/redux';
import { setError } from '../appStatus';

export const requestSuggestions =
  (query: string): TThunkAction<Promise<void>> =>
  async (dispatch, _getState, context) => {
    try {
      const {
        httpApi,
        logger,
        custom: { subdomain },
      } = context;

      dispatch(suggestionsRequest());

      const suggestions = await fetchSuggestions({
        httpApi,
        logger,
        query,
        subdomain,
      });

      dispatch(suggestionsSuccess(suggestions));
    } catch (error) {
      context.logger.error(error, {
        comment: 'Ошибка при запросе за suggestions.',
      });

      dispatch(suggestionsFailure());
      dispatch(setError('Что-то пошло не так. Пожалуйста, попробуйте еще раз.'));
    }
  };
